<div *ngIf="data" [class]="data.isEqualSection ? 'container-sm' : 'container-xxl'">
  <div class="row">
    <ng-container [ngSwitch]="data.teasers.length">
      <mb-card
        (click)="openCardMedia(data.teasers[0])"
        *ngSwitchCase="1"
        class="col-12 single-card"
        [class.is-equal]="data.isEqualSection"
        [data]="data.teasers[0]"
        [layouts]="largeLayouts"
        [actions]="data.teasers[0].actions || []"
        alignContent="bottom"
      >
        <figure>
          <mb-media [media]="data.teasers[0].media" [hoverplay]="true"></mb-media>
        </figure>
      </mb-card>

      <ng-container *ngSwitchCase="2">
        <div *ngFor="let item of data.teasers" class="col-12 col-sm-6 two-cards" [class.is-equal]="data.isEqualSection">
          <mb-card
            (click)="openCardMedia(item)"
            [data]="item"
            [layouts]="smallLayout"
            [actions]="item.actions"
            [alignContents]="smallAlignments"
          >
            <figure>
              <mb-media [media]="item.media" [hoverplay]="true"></mb-media>
            </figure>
          </mb-card>
        </div>
      </ng-container>

      <div *ngSwitchDefault class="teaser-container three-cards">
        <mb-card
          (click)="openCardMedia(data.teasers[0])"
          [data]="data.teasers[0]"
          [layouts]="largeLayouts"
          [actions]="data.teasers[0].actions"
          alignContent="bottom"
        >
          <figure>
            <mb-media [media]="data.teasers[0].media" [hoverplay]="true"></mb-media>
          </figure>
        </mb-card>
        <mb-card
          (click)="openCardMedia(data.teasers[1])"
          [data]="data.teasers[1]"
          [layouts]="smallLayout"
          [actions]="data.teasers[1].actions"
          [alignContents]="smallAlignments"
        >
          <figure>
            <mb-media [media]="data.teasers[1].media" [hoverplay]="true"></mb-media>
          </figure>
        </mb-card>
        <mb-card
          (click)="openCardMedia(data.teasers[2])"
          [data]="data.teasers[2]"
          [layouts]="smallLayout"
          [actions]="data.teasers[2].actions"
          [alignContents]="smallAlignments"
        >
          <figure>
            <mb-media [media]="data.teasers[2].media" [hoverplay]="true"></mb-media>
          </figure>
        </mb-card>
      </div>
    </ng-container>
  </div>
</div>
